"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adler32 = void 0;
const adler32 = data => {
  const MOD_ADLER = 65521;
  const BITS_MOVED = 16;
  const {
    length
  } = data;
  let a = 1;
  let b = 0;
  for (let i = 0; i < length; i++) {
    // eslint-disable-next-line unicorn/prefer-code-point -- x
    a += data.charCodeAt(i);
    b += a;
  }
  a %= MOD_ADLER;
  b %= MOD_ADLER;

  // eslint-disable-next-line no-bitwise -- x
  return b << BITS_MOVED | a;
};
exports.adler32 = adler32;